export default "__VITE_ASSET__099ccf37__"